import { ANNA_LINK } from '../helpers/constants'
import { fetchCampaigns } from '../helpers/api'

export async function suggestAlternativesWhenNoResults () {
  const container = document.getElementsByClassName('empty-results')[0]

  // No results text
  const text1 = document.createElement('p')
  text1.classList.add('fw-600')
  text1.innerText = '¡Lo sentimos! No hemos encontrado lo que buscas...'

  // ANNA div
  const annaDiv = document.createElement('div')
  const annaText = document.createElement('p')
  annaText.innerText = 'Mientras seguimos trabajando para mejorar la vida con niños, puedes preguntar a ANNA, nuestra asistente de planes en familia'
  const annaLink = document.createElement('a')
  annaLink.id = 'anna-link'
  annaLink.href = ANNA_LINK
  annaLink.innerText = 'Preguntar a ANNA'
  annaDiv.appendChild(annaText)
  annaDiv.appendChild(annaLink)

  // Campaigns
  const campTitle = document.createElement('p')
  campTitle.innerText = 'También te pueden interesar'

  const campDiv = document.createElement('div')
  campDiv.id = 'campaigns'
  const campaigns = await fetchCampaigns()
  campDiv.appendChild(createCampBlock(campaigns[0]))
  campDiv.appendChild(createCampBlock(campaigns[1]))
  campDiv.appendChild(createCampBlock(campaigns[2]))

  // Add all sections to container
  container.appendChild(text1)
  container.appendChild(annaDiv)
  container.appendChild(campTitle)
  container.appendChild(campDiv)
}

function createCampBlock (campaign) {
  const campBlock = document.createElement('a')
  campBlock.classList.add('camp-block-horizontal')
  campBlock.href = campaign.campaign_url
  campBlock.innerText = campaign.name

  return campBlock
}
